export default function (state = {
  environment: 'master',
  debug: false,
}) {
  return state;
}
